@if (currentApplicationControlMode !== SystemControlMode.NotSupported) {
  <div class="control-state-container" [ngClass]="'control-mode-' + SystemControlMode[currentApplicationControlMode]" data-test-id="system-control-mode-toggle">
    <div class="controls">
      @if (currentApplicationControlMode === SystemControlMode.Unknown) {
        <div class="icon-message">
          <gbc-icon iconName="auto-mode"></gbc-icon>
          <span class='icon-text'>{{ 'control-state-toggle.text.unknown' | translate }}</span>
        </div>
      }
      @if (currentApplicationControlMode === SystemControlMode.Auto) {
        <div class="icon-message">
          <gbc-icon iconName="auto-mode"></gbc-icon>
          <span class='icon-text'>{{ 'control-state-toggle.text.auto' | translate }}</span>
        </div>
      }
      @if (currentApplicationControlMode === SystemControlMode.Manual) {
        <div class="icon-message">
          <gbc-icon iconName="manual-mode"></gbc-icon>
          <span class='icon-text'>{{ 'control-state-toggle.text.manual' | translate }}</span>
        </div>
      }
      <div class="choose-control-mode">
        <p-selectButton class='choose-control-mode-buttons' [options]="controlOptions" [(ngModel)]="controlMode" (onChange)="selectedApplicationControlMode.emit(controlMode)">
          <ng-template let-item>
            <span style="margin-right: 15px">{{ item.name }}</span>
            @if (item.value === controlMode) {
              <i class="pi pi-check"></i>
            }
          </ng-template>
        </p-selectButton>
      </div>
    </div>
    @if (controlMode !== currentApplicationControlMode) {
      <div>
        @if (controlMode === SystemControlMode.Auto) {
          <p class="detailed-message auto-mode">
            {{ 'control-state-toggle.message.auto' | translate }}
          </p>
        }
        @if (controlMode === SystemControlMode.Manual) {
          <p class="detailed-message manual-mode">
            {{ 'control-state-toggle.message.manual' | translate }}
          </p>
        }
      </div>
    }
  </div>
}
